import PaymentPage from "@/pages/PaymentPage";

export default function FinancePage() {
  return (
    <div className="animate-slideUp space-y-6" data-testid="finance-page">
      <p className="text-sm text-slate-500">Manage your payment method</p>
      <PaymentPage />
    </div>
  );
}
